import { getReaderFocus } from './getReaderFocus';
import { getReaderLanguages } from './getReaderLanguages';

// build object of reader-data to help filter
export function buildReadersObject(data) {
  if (!data) {
    return undefined;
  }

  const allReaders = [];
  data.forEach((reader) => {
    const readerObj = {
      id: reader.id,
      name: [reader.acf.reader_profile_description_fullname],
      location: [reader.acf.reader_profile_description_location],
      languages: getReaderLanguages(reader),
      focus: getReaderFocus(reader),
    };
    allReaders.push(readerObj);
  });
  return allReaders;
}
